import { Box, Chip } from '@mui/material'
import { getCodeSetLabelLookup } from '../../../Functions/CodeSetFns'
import * as React from 'react'
import { GridRenderCellParams } from '@mui/x-data-grid-pro'
import { tsScreenHoldings } from '../../../Typescript/API_Response'
import { useUserContext } from '../../../Contexts/UserConfig'
import { CheckCircle, DonutLarge, HourglassEmpty } from '@mui/icons-material'

function HoldingStatusIcon({
  holding,
  screenID,
  holdings,
}: {
  holding: any
  screenID: number
  holdings: any[] | undefined
}) {
  const foundHoldings =
    holdings ?
      holdings?.filter(
        (item) => item.ScreenID === screenID && item.HoldingID === holding,
      )
    : []
  if (foundHoldings.length > 0) {
    const status = foundHoldings[0].CollectionStatus
    switch (status) {
      case 'INP':
        return <DonutLarge />
      case 'CPT':
        return <CheckCircle />
      default:
        return <HourglassEmpty />
    }
  }
  return <HourglassEmpty />
}

export function ScreenManageDGHoldingChips({
  holdings,
  value,
  row,
}: GridRenderCellParams & { holdings: tsScreenHoldings[] | undefined }) {
  const { loginConfig } = useUserContext()
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        flexDirection: 'column',
      }}
    >
      {value &&
        value.map((val: any) => (
          <Chip
            key={val}
            sx={{ m: 1 / 3 }}
            label={getCodeSetLabelLookup(loginConfig, ['KV-Holdings'], val)}
            icon={
              <HoldingStatusIcon
                holding={val}
                screenID={row.ScreenID}
                holdings={holdings}
              />
            }
          />
        ))}
    </Box>
  )
}
